module.exports = __webpack_public_path__ + "static/media/smartphone.67a48767.jpg";